// HappyVan Monthly Move Prize Draw - content and terms.
// Terms text is published exactly as supplied by the promoter.

export const prizeDraw = {
  headline: 'Win your move back - up to £500',
  subline:
    "Book any move with HappyVan and you're automatically entered into our monthly prize draw, at no extra cost.",
  teaser: 'Book this month and you could win your move back - up to £500',
  maxPrize: '£500',

  promoter: {
    legalName: 'Coastline Removal Services Ltd',
    tradingAs: 'HappyVan',
    address: '7a Church Street, Brighton, BN1 1US',
    companyNumber: '15857795',
    phone: '01273 044565',
    email: 'tristan@happyvan.co',
    website: 'happyvan.co'
  },

  // T&Cs publication date, shown at the foot of /prize-draw-terms.
  lastUpdated: 'June 2026',

  // Plain-English draw timing used in marketing copy (clause 5.2 is the binding wording).
  drawTiming: 'The draw takes place at the beginning of every month.',

  steps: [
    {
      number: '1',
      title: 'Book your move',
      body: 'Call or WhatsApp us. Any size, anywhere in Sussex.'
    },
    {
      number: '2',
      title: 'Move & pay',
      body: 'Complete your move and pay your invoice in full that month.'
    },
    {
      number: '3',
      title: 'You could win',
      body: 'One customer a month wins their move cost back, up to £500.'
    }
  ],

  keyTerms: [
    { label: 'Promoter', value: 'Coastline Removal Services Ltd t/a HappyVan' },
    { label: 'Draw frequency', value: 'Monthly draw, rolling' },
    { label: 'Who can enter', value: 'UK residents 18+' },
    { label: 'Entries', value: 'One entry per completed and paid booking' },
    { label: 'Draw date', value: 'Drawn at the beginning of every month' },
    { label: 'Winner contact', value: 'Winner contacted by phone/email' },
    { label: 'Maximum prize', value: 'Max prize £500' }
  ],

  // Past winners are only shown once there is real data.
  // Shape: { name: 'Sarah', area: 'Hove', month: 'June 2026', amount: '£420' }
  pastWinners: [],

  terms: [
    {
      heading: '1. The Promotion',
      clauses: [
        '1.1 The HappyVan Monthly Move Prize Draw ("the Draw") is a prize draw open to eligible customers who complete and pay for a furniture removal or moving service with HappyVan during the relevant calendar month ("the Promotion Period"). There is no additional charge to enter.',
        '1.2 The Draw is operated by Coastline Removal Services Ltd t/a HappyVan ("the Promoter").',
        "1.3 The Draw runs on a rolling monthly basis with no fixed end date, and may be withdrawn or amended by the Promoter at any time with reasonable notice published on the Promoter's website and Instagram page (@happyvanbrighton)."
      ]
    },
    {
      heading: '2. Eligibility',
      clauses: [
        '2.1 Entry is open to UK residents aged 18 or over.',
        "2.2 To be eligible, an entrant's move must have been completed, and their invoice paid in full, within the relevant calendar month.",
        '2.3 One entry per booking. Multiple bookings in the same month do not generate additional entries.',
        '2.4 Employees, directors, contractors and immediate family members of Coastline Removal Services Ltd are not eligible to enter.'
      ]
    },
    {
      heading: '3. How to Enter',
      clauses: [
        "3.1 Customers whose move is completed and paid for within the Promotion Period are automatically entered into that month's Draw. No further action is required.",
        '3.2 Bookings that do not meet these Terms & Conditions will not be entered.'
      ]
    },
    {
      heading: '4. The Prize',
      clauses: [
        '4.1 One winner will be selected each calendar month.',
        "4.2 The prize is a full reimbursement of the winner's move cost, up to a maximum of £500 (\"the Prize\"). Where the winner's move cost exceeds £500, only £500 will be reimbursed.",
        '4.3 The Prize will be paid by bank transfer, or another method agreed with the winner, within 28 days of the winner being verified and confirmed.',
        "4.4 Only entrants whose payment for the move has fully cleared by the date of the draw are eligible to win. Where a winner's payment has not cleared by the draw date, the Promoter reserves the right to select an alternative winner from that month's eligible entrants.",
        '4.5 The Prize is non-transferable and non-exchangeable.',
        '4.6 Only one Prize will be awarded per calendar month, and no more than one Prize per household.'
      ]
    },
    {
      heading: '5. The Draw & Winner Notification',
      clauses: [
        '5.1 The winner will be selected at random from all eligible entries in the Promotion Period, using a method that gives each eligible entry an equal chance of winning.',
        '5.2 The draw will take place within 5 working days of the end of each calendar month.',
        '5.3 The winner will be notified by telephone and/or email, using the contact details provided at the time of booking, within 3 working days of the draw.',
        '5.4 If the winner cannot be contacted, or does not respond to confirm acceptance of the Prize within 7 days of the first notification attempt, the Promoter reserves the right to select an alternative winner from the remaining eligible entries for that month.',
        '5.5 With the winner\'s agreement, given when accepting the Prize, the winner\'s first name and town/area (e.g. "Sarah, Hove") may be announced on the Promoter\'s Instagram (@happyvanbrighton) and Facebook pages, website and other marketing materials.'
      ]
    },
    {
      heading: '6. Data Protection',
      clauses: [
        '6.1 Personal data used for the Draw (name, contact details, address, and move and payment details) will be processed by the Promoter in accordance with UK GDPR and the Data Protection Act 2018.',
        '6.2 Personal data will be used solely to administer the Draw, contact the winner and, where consent has been given, send marketing communications. It will not be sold or shared with third parties for their own marketing purposes.',
        "6.3 Entrants' data will be kept only for as long as necessary to administer the Draw and meet legal and accounting obligations, after which it will be securely deleted.",
        '6.4 Entrants have the right to access, correct or request deletion of their personal data by contacting tristan@happyvan.co. See our Privacy Policy for more information.'
      ]
    },
    {
      heading: '7. General',
      clauses: [
        '7.1 By being entered into the Draw, entrants agree to be bound by these Terms & Conditions.',
        "7.2 The Promoter's decision in relation to all aspects of the Draw is final and binding.",
        '7.3 The Promoter reserves the right to amend these Terms & Conditions, or to cancel, suspend or withdraw the Draw, if deemed necessary in its opinion or if circumstances arise outside its control.',
        '7.4 The Promoter is not responsible for any failure to administer the Draw due to technical failures or circumstances beyond its reasonable control.',
        '7.5 These Terms & Conditions are governed by the laws of England and Wales, and entrants submit to the exclusive jurisdiction of the courts of England and Wales.',
        '7.6 This promotion is not sponsored, endorsed, administered by or associated with any social media platform, including Instagram or Facebook.'
      ]
    }
  ]
};

export default prizeDraw;
